import { translate } from '../../helpers/translate.helper';
import { useOpenFreshchat } from '../../hooks/useOpenFreshchat';
import { IconMessageCircle } from '../../icons/cdl/MessageCircle';
import { useShortcutMenu } from '../hooks/useShortcutMenu';

import { CommandItem } from './CommandItem';

export const OpenSupportChat = () => {
    const openFreshchat = useOpenFreshchat();
    const { setOpen } = useShortcutMenu();

    return (
        <CommandItem
            onSelect={() => {
                void openFreshchat();
                setOpen(false);
            }}
            Icon={IconMessageCircle}
        >
            {translate('navigation.messageUs')}
        </CommandItem>
    );
};
